import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const editTelematicsDiscount = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.edit_telematics_discount');
